module.exports = __webpack_public_path__ + "static/media/12.bf215c5a.jpg";